<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Agent Group Infos</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
                <v-card>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Agent Group Details</div>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row>
                      <v-flex xs6>
                        <div class="subheading">
                          <b> Agent Name:</b> {{ editedItem.first_name }}
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <div class="subheading">
                          <b> Agent Mobile Number:</b> {{ editedItem.phone }}
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <div class="subheading">
                          <b>Group Name:</b> {{ editedItem.name }}
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <div class="subheading">
                          <b> Group Code:</b> {{ editedItem.agent_group_code }}
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <div class="subheading">
                          <b> Agent's Agreement:</b>
                          {{ editedItem.AgentAgreement }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-flex>
          </v-layout>
          <!-- <v-divider inset></v-divider> -->
          <v-container fluid>
            <v-layout row>
              <div>
                <v-btn color="red" @click="close">Cancel</v-btn>
              </div>
            </v-layout>
          </v-container>
        </template>
      </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
    <div v-if="alertMsg">
      <v-alert
        v-if="error == 0 && statusCode == 200"
        :value="true"
        type="success"
        transition="slide-y-reverse-transition"
        >{{ errorMsg }}</v-alert
      >
      <v-alert
        v-if="error == 1 && statusCode == 204"
        :value="true"
        type="info"
        transition="slide-y-reverse-transition"
        >{{ errorMsg }}</v-alert
      >
      <v-alert
        v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
        :value="true"
        type="warning"
        transition="slide-y-reverse-transition"
        >{{ errorMsg }}</v-alert
      >
      <v-alert
        v-if="error == 1 && statusCode == 500"
        :value="true"
        type="error"
        transition="slide-y-reverse-transition"
        >{{ errorMsg }}</v-alert
      >
    </div>
    <div v-if="isLoaded">
      <div v-if="indexData.totalVerified < 0" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.verifiedAgentGroupInfos.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        hide-actions
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.totalVerified > 0" v-slot:items="props">
          <td>{{ props.item.dasher_id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.agent_group_code }}</td>
          <td>{{ props.item.first_name }}</td>
          <td>{{ props.item.ActiveStatus }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.verifiedAgentGroupInfos.from }} -
          {{ indexData.verifiedAgentGroupInfos.to }} of
          {{ indexData.verifiedAgentGroupInfos.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.verifiedAgentGroupInfos.current_page"
            :length="indexData.verifiedAgentGroupInfos.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    alertMsg: false,
    apiUrl: "agent.group.members-status",
    sl: 1,
    headers: [
      { text: "Agent ID", align: "left", value: "dasher_id" },
      { text: "Group Name", align: "left", value: "name" },
      { text: "Group Code", align: "left", value: "agent_group_code" },
      { text: "Dasher Name", value: "first_name" },
      { text: "Active Status", value: "ActiveStatus" },
      { text: "Actions", align: "center", value: "first_name", sortable: false },
    ],
    loading: false,
    search: "",
    pagination: {},
    rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isLoaded() {
      if (this.indexData.verifiedAgentGroupInfos) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    pagination() {
      this.onPageChange();
    },
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    initialize() {
      this.$store.dispatch("changeDasherTeamStatus", [
        "agent.group.members-status",
        1,
        "",
        1,
        5,
      ]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    checkItem(item) {
      // console.log(item)
      this.editedIndex = this.indexData.verifiedAgentGroupInfos.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    onPageChange() {
      this.verifiedPaginationMethod();
    },

    verifiedPaginationMethod() {
      // console.log(this.search)
      this.loading = true;

      if (this.search) {
        this.$store.dispatch("changeDasherTeamStatus", [
          "agent.group.members-status",
          1,
          this.search,
          this.indexData.verifiedAgentGroupInfos.current_page,
          this.pagination.rowsPerPage,
        ]);
        this.loading = this.indexData.verifiedAgentGroupInfos.data ? false : true;
      } else {
        this.$store.dispatch("changeDasherTeamStatus", [
          "agent.group.members-status",
          1,
          this.search,
          this.indexData.verifiedAgentGroupInfos.current_page,
          this.pagination.rowsPerPage,
        ]);
        this.loading = !this.indexData.error ? false : true;
      }
      this.dialog = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
.v-progress-circular
  margin: 1rem

.imageResize
  width: auto
  height: auto
</style>
